import AddResearchTeamMember from "../AddResearchTeamMember";
import AnimalProtocolSearch from "../AnimalProtocolSearch/AnimalProtocolSearch";
import Checkboxes from "../Checkboxes";
import ClassificationCodes from "../ClassificationCodes";
import COIComponent from "../COIComponent";
import CopyToFrom from "../CopyToFrom/CopyToFrom";
import DataTable from "../DataTable";
import { ExpressionField } from "../ExpressionField";
import { FileInput } from "../FileInput";
import FlowableOrgSearch from "../FlowableOrgSearch";
import FlowablePersonSearch from "../FlowablePersonSearch";
import FlowableRichText from "../FlowableRichText";
import FlowableUnitSearch from "../FlowableUnitSearch";
import { FundingProgram } from "../FundingProgram";
import HaploCostingTool from "../HaploCostingTool/HaploCostingTool";
import HaploEthicsMonitor from "../HaploEthicsMonitor/HaploEthicsMonitor";
import HaploRepository from "../HaploRepository/HaploRepository";
import HazardSafetySearch from "../HazardSafetySearch/HazardSafetySearch";
import HumanEthicsStudySearch from "../HumanEthicsStudySearch/HumanEthicsStudySearch";
import IRBStudy from "../IRBStudy/IRBStudy";
import NumberComponent from "../Number";
import PeriodsDefinitionForm from "../PeriodsDefinitionForm";
import ProposalsS2SRecord from "../ProposalsS2SRecord/ProposalsS2SRecord";
import ResearchTeam from "../ResearchTeam";
import ResearchTeamBudget from "../ResearchTeamBudget/ResearchTeamBudget";
import ResearchTeamBudgetImporter from "../ResearchTeamBudgetImporter";
import SelectedRateTypeTable from "../SelectedRateTypeTable/SelectedRateTypeTable";
import SFIComponent from "../SFIComponent";
import SummaryBudget from "../SummaryBudget";

const Components = {
	researchTeam: ResearchTeam,
	dataTable: DataTable,
	copyToFrom: CopyToFrom,	// No longer used
	classificationCodes: ClassificationCodes,
	addResearchTeamMember: AddResearchTeamMember, // No longer used
	periodsDefinitionForm: PeriodsDefinitionForm, // No longer used
	selectedRateTypeTable: SelectedRateTypeTable, // No longer used
	cayuseIrbStudy: IRBStudy,
	cayuseProposalsS2SRecord: ProposalsS2SRecord,
	cayuseResearchTeamBudget: ResearchTeamBudget, // No longer used in new forms, Leaving in for old forms (8/01/2021). Hidden from SFB Palette with option in component
	cayuseResearchTeamBudgetImporter: ResearchTeamBudgetImporter, // No longer used in new forms, Leaving in for old forms (8/01/2021). Hidden from SFB Palette with option in component
	cayuseHumanEthicsStudySearch: HumanEthicsStudySearch,
	cayuseAnimalOversight: AnimalProtocolSearch,
	cayuseHazardSafety: HazardSafetySearch,
	cayuseHaploCostingTool: HaploCostingTool,
	cayuseHaploEthicsMonitor: HaploEthicsMonitor,
	cayuseHaploRepository: HaploRepository,
	cayuseSignificantFinancialInterest: SFIComponent,
	cayuseSummaryBudgetImporter: SummaryBudget, // New budget Importer (8/01/2021)
	cayuseCheckboxes: Checkboxes,
	one: NumberComponent,
	number: NumberComponent,
	cayuseCOIComponent: COIComponent, // No longer used
	fileInput: FileInput,
	expressionField: ExpressionField,
	personFinder: FlowablePersonSearch,
	unitFinder: FlowableUnitSearch,
	orgFinder: FlowableOrgSearch,
	richText: FlowableRichText,
	fundingProgram: FundingProgram,
};

export default Components;
